module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', [_c('div', {
    staticClass: "page-heading",
    class: {
      menuShowing: _vm.menuShowing
    }
  }, [_c('div', {
    staticClass: "menu-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('div', {
    staticClass: "side-menu-button menu-button",
    on: {
      "click": _vm.toggleMenu
    }
  }, [_c('i', {
    staticClass: "fa fa-navicon"
  })]), _vm._v(" "), _c('h1', [_c('i', {
    staticClass: "fa",
    class: _vm.$route.meta.icon
  }), _vm._v(" \n\t\t\t" + _vm._s(_vm.pageTitle.mainTitle) + " \n\t\t\t"), (_vm.pageTitle.subTitle) ? _c('small', [_vm._v(_vm._s(_vm.pageTitle.subTitle))]) : _vm._e()]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.mutatedRoutes), function(route) {
    return (route.showRoute && route.meta.navGroup.indexOf('top') >= 0) ? _c('li', [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: route.meta.icon
    }), _vm._v(" "), _c('div', [_vm._v(_vm._s(route.meta.titleText))])])], 1) : _vm._e()
  }))]), _vm._v(" "), _c('nav', {
    staticClass: "menu",
    class: {
      menuShowing: _vm.menuShowing
    }
  }, [_c('div', {
    staticClass: "menu-block"
  }, [_c('h2', {
    staticClass: "menu-heading"
  }, [_vm._v("\t\t\n\t\t\t\tManage \n\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.mutatedRoutes), function(route) {
    return (route.showRoute && route.meta.navGroup.indexOf('main') >= 0) ? _c('li', [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: route.meta.icon
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(route.meta.titleText) + "\n\t\t\t\t\t")])], 1) : _vm._e()
  }))]), _vm._v(" "), _c('div', {
    staticClass: "menu-block"
  }, [_c('h2', {
    staticClass: "menu-heading"
  }, [_vm._v("\t\t\n\t\t\t\tSettings \n\t\t\t")]), _vm._v(" "), _c('ul', {
    staticClass: "menu-list"
  }, _vm._l((_vm.mutatedRoutes), function(route) {
    return (route.showRoute && route.meta.navGroup.indexOf('app') >= 0) ? _c('li', [_c('router-link', {
      attrs: {
        "to": route.path
      }
    }, [_c('i', {
      staticClass: "fa fa-fw",
      class: route.meta.icon
    }), _vm._v("\n\t\t\t\t\t\t" + _vm._s(route.meta.titleText) + "\n\t\t\t\t\t")])], 1) : _vm._e()
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d0d538fc","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/DashboardHeader.vue
// module id = 307
// module chunks = 0